import React from 'react';
import IconWrapper from '../../../IconWrapper';
const ChevronLeftIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { d: "M4 8a.5.5 0 0 1 .162-.369l6-5.5a.5.5 0 0 1 .676.738L5.24 8l5.598 5.131a.5.5 0 0 1-.676.738l-6-5.5A.5.5 0 0 1 4 8Z" })));
export default ChevronLeftIconSmall;
//# sourceMappingURL=ChevronLeftIconSmall.js.map